<template>
  <div class="md:pb-12 lg:pb-12 py-6 mt-12 relative" id="serviceform">
    <div class="absolute bg-design-mbr-ell mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr ell.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-mbr-ell2 mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr ell.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-mbr-poly-hcp mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr-poly.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="relative">
      <div class="">
        <div class="md:w-3/5 lg:w-2/5 w-3/5 bg-E3CEFF-mbr">
          <img
            src="../../../assets/images/caregiver/mbr-bg.svg"
            alt="bg polygon"
          />
        </div>
      </div>
      <div class="membership-negmt text-black z-10">
        <div
          class="md:w-4/5 lg:w-4/5 w-full px-4 md:px-0 lg:px-0 mt-8 mx-auto md:pt-12 lg:pt-12 pt-0"
        >
          <div
            class="md:pt-10 lg:pt-10 pt-2 grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 grid-rows-1 md:gap-12 lg:gap-12 gap-6 w-full"
          >
            <div
              class="col-span-2 bg-primary md:rounded-3xl lg:rounded-3xl rounded-xl md:p-8 lg:p-8 p-4 shadow-b-2xl relative trans-zoom-half"
            >
              <div>
                <div v-if="secondpage">
                  <validation-observer
                    v-slot="{ handleSubmit }"
                    ref="formValidator"
                  >
                    <b-form
                      role="form"
                      @submit.prevent="handleSubmit(handleSend)"
                      id="shopRegisterService"
                    >
                      <div class="justify-between">
                        <p class="font-bold text-white fsize35-20 mb-2">
                          Request For Services
                        </p>

                        <p
                          class="subtitle text-white py-2 w-full fsize18-14-32px"
                        >
                          Kindly Sign-in and fill in the details below and we
                          will get in touch with you.
                        </p>
                      </div>
                      <div class="">
                        <p class="input-title">
                          Which services are you interested in
                        </p>
                        <multiselect
                          class="cust-hScroller"
                          v-model="value"
                          :options="options1"
                          :multiple="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder=""
                          label="name"
                          track-by="name"
                          :preselect-first="false"
                        >
                        </multiselect>
                      </div>
                      <div
                        class="pt-6 grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 grid-rows-2 gap-x-5 gap-y-2"
                      >
                        <div class="">
                          <p class="input-title">Name</p>
                          <base-input
                            v-model="fullname"
                            placeholder="Enter your name"
                            class="md:border-0 lg:border-0"
                            name="Name"
                            :rules="{ required: true, regex: '^[a-zA-Z ]+$' }"
                          ></base-input>
                        </div>
                        <div class="">
                          <p class="input-title">Email Address</p>
                          <base-input
                            v-model="email"
                            placeholder="Enter your EmailID"
                            class="md:border-0 lg:border-0"
                            name="Email"
                            :rules="{ required: true, email: true }"
                          ></base-input>
                        </div>
                        <div class="">
                          <p class="input-title">Contact No.</p>
                          <base-input
                            v-model="mobile"
                            placeholder="Enter your Contact No."
                            class="md:border-0 lg:border-0"
                            name="Mobile no"
                            :rules="{ required: true, regex: '^[0-9]{10}$' }"
                          ></base-input>
                        </div>
                        <div class="">
                          <p class="input-title">City</p>
                          <base-input
                            v-model="location"
                            placeholder="Enter your Locality Name"
                            class="md:border-0 lg:border-0"
                            name="City"
                            :rules="{ required: true, regex: '^[a-zA-Z]+$' }"
                          ></base-input>
                        </div>
                      </div>
                      <div
                        v-if="
                          value.some((val) => val.name === 'Care Assistance')
                        "
                        class="flex gap-5 mt-2"
                      >
                        <div class="w-1/2">
                          <p class="input-title">Location</p>
                          <base-input
                            v-model="currentLocation"
                            placeholder="Enter your Locality Name"
                            class="md:border-0 lg:border-0"
                            name="City"
                            :rules="{ required: true, regex: '^[a-zA-Z]+$' }"
                          ></base-input>
                        </div>
                        <div class="w-1/2">
                          <p class="input-title">Pincode</p>
                          <base-input
                            v-model="pincode"
                            placeholder="Enter your Pincode"
                            class="md:border-0 lg:border-0"
                            name="City"
                            :rules="{ required: true, regex: '^[1-9]+$' }"
                          ></base-input>
                        </div>
                      </div>

                      <div class="lg:flex md:flex grid gap-5 mt-2">
                        <div class="lg:w-1/2 md:w-1/2 w-full">
                          <p class="input-title">
                            Gender of the care attendant
                          </p>
                          <!-- <base-input
                            v-model="careAttendantGender"
                            placeholder="Enter Gender of the care attendant"
                            class="md:border-0 lg:border-0"
                            name="Gender"
                            :rules="{ required: true }"
                          ></base-input> -->
                          <b-form-select
                            v-model="careAttendantGender"
                            class="md:border-0 lg:border-0"
                          >
                            <b-form-select-option
                              v-for="option in genderOptions"
                              :value="option.value"
                              :key="option.value"
                              name="Relationship"
                              :rules="{ required: true }"
                              >{{ option.text }}
                            </b-form-select-option>
                          </b-form-select>
                        </div>
                        <div class="lg:w-1/2 md:w-1/2 w-full">
                          <p class="input-title">Hours</p>
                          <base-input
                            v-model="hours"
                            placeholder="Enter Hours"
                            class="md:border-0 lg:border-0"
                            name="Hours"
                            :rules="{ required: true }"
                          ></base-input>
                        </div>
                      </div>

                      <div class="mt-2">
                        <p class="input-title">
                          Relationship with Care Recipient
                        </p>
                        <b-form-select
                          v-model="selected"
                          placeholder="Select it"
                        >
                          <b-form-select-option
                            v-for="option in options"
                            :value="option"
                            :key="option._id"
                            name="Relationship"
                            :rules="{ required: true }"
                            :disabled="option.disabled"
                            >{{ option.text }}
                          </b-form-select-option></b-form-select
                        >
                      </div>

                      <div class="md:mt-4 mt-8 lg:mt-8 mb-12 bottom6-4 w-full">
                        <b-button
                          type="next"
                          variant="secondary"
                          class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 border-2 text-base font-bold"
                          @click="second()"
                          >Next</b-button
                        >
                      </div>
                    </b-form>
                  </validation-observer>
                </div>

                <div v-if="firstpage">
                  <Reg2Service
                    :firstPage="firstpage"
                    :secondPage="secondpage"
                    @clearData="clearData"
                  />
                </div>

                <div class="flex justify-center">
                  <div class="custom-pagination">
                    <div
                      class="bg-white h-2 mr-4 w-16 cursor-pointer"
                      @click="first()"
                    ></div>
                    <div class="bg-primary h-1 w-16 cursor-pointer"></div>
                  </div>
                  <div class="custom-pagination">
                    <div
                      class="bg-white h-2 mr-4 w-16 cursor-pointer"
                      @click="second()"
                    ></div>
                    <div class="bg-primary h-1 w-16 cursor-pointer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Reg2Service from "./Reg2Service.vue";
import emailMixin from "@/mixins/email";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  mixins: [emailMixin],
  data() {
    return {
      selected: null,
      value: [],
      firstpage: false,
      secondpage: true,
      fullname: "",
      name: "",
      options: [
        {
          value: null,
          text: "Please select an option",
          disabled: true,
          selected: true,
        },
        { value: "a", text: "Primary Caregiver" },
        { value: "b", text: "Wellwisher" },
        { value: "c", text: "Long Distance Caregiver" },
      ],
      genderOptions: [
        { value: null, text: "Please select gender" },
        { value: "Male", text: "Male" },
        { value: "Female", text: "Female" },
        { value: "Other", text: "Other" },
      ],

      options1: [
        { name: "Caregiver Coaching" },
        { name: "Family Counseling" },
        {
          name: "Caregiver counseling and therapy",
        },
        { name: "Care Assistance" },
        { name: "Will and Inheritance" },
      ],

      relation: "",
      email: "",
      mobile: "",
      location: "",
      currentLocation: "",
      pincode: "",
      careAttendantGender: null,
      hours: "",
      formData: {},
    };
  },

  components: {
    Reg2Service,
    Multiselect,
  },

  methods: {
    clearData() {
      this.careAttendantGender = null;
      this.hours = "";
      this.location = "";
      this.currentLocation = "";
      this.pincode = "";
      this.mobile = "";
      this.email = "";
      this.relation = "";
      this.fullname = "";
      this.name = "";
      this.selected = null;
      this.value = [];
      this.formData = {};
    },
    first() {
      this.firstpage = false;
      this.secondpage = true;
    },
    second() {
      this.formData = {
        name: this.fullname,
        relation: this.selected.text,
        email: this.email,
        mobile: this.mobile,
        location: this.location,
        value: this.value,
      };
      if (this.careAttendantGender) {
        Object.assign(this.formData, {
          careAttendantGender: this.careAttendantGender,
        });
      }
      if (this.hours) {
        Object.assign(this.formData, {
          hours: this.hours,
        });
      }
      if (this.pincode) {
        Object.assign(this.formData, {
          pincode: this.pincode,
        });
      }
      if (this.currentLocation) {
        Object.assign(this.formData, {
          currentLocation: this.currentLocation,
        });
      }
      this.firstpage = true;
      this.secondpage = false;
      this.$store.commit("services/SET_REG", this.formData);
    },
    init() {
      this.$store.dispatch("eLearning/getProfile", {
        userId: this.userData._id,
      });
    },
  },
  mounted() {
    if (!!Object.keys(this.user).length) {
      this.email = this.user.email;
      this.fullname = `${this.user.firstname} ${this.user.lastname}`;
      this.mobile = this.user.mobile;
    }
    // this.init();
    // console.log(this.profileData, "pdata");
    // console.log(this.userData, "udata");
    // if (this.userData.firstname && this.userData.lastname) {
    //   this.fullname = this.userData.firstname + " " + this.userData.lastname;
    // }
    // this.$store.dispatch("services/getpartner");
    // console.log(this.get_AllPartner);
    // this.get_AllPartner.forEach((x) => {
    //   const array = this.options1.push({
    //     name: x.title,
    //   });
    // });
    // console.log(this.options1);
  },
  computed: {
    ...mapState("auth", ["userData", "user"]),
    ...mapState("services", ["setregform"]),
    ...mapState("eLearning", ["profileData"]),
    ...mapState("services", { get_AllPartner: "get_AllPartner" }),

    isValidForm() {
      if (this.otp == "") {
        return true;
      } else if (
        this.name != "" &&
        this.email != "" &&
        this.designation != "" &&
        this.company != "" &&
        this.mobile != "" &&
        this.message != ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    isdisabled() {
      // return true;
      // if (this.status == "I have read and agreed to these") {
      //   return true;
      // } else {
      //   return false;
      // }
      if (
        this.name == "" ||
        this.email == "" ||
        this.relation == "" ||
        this.mobile == "" ||
        this.location == "" ||
        this.value.length === 0
      ) {
        // if (value.some((val) => val.name === "Care Assistance")) {
        //   if (this.careAttendantGender == "" || this.hours == "") {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // } else {
        //   return true;
        // }
        // console.log("test");
        return true;
      } else {
        // console.log("test1");
        return false;
      }
    },
  },
};
</script>
